module.exports = __webpack_public_path__ + "static/img/视频认证范例.2ee19d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/视频认证范例.jpg
// module id = dObJ
// module chunks = 1